import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

function resolveSocketUrl() {
  let url = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  if (url.endsWith('/api')) url = url.slice(0, -4);
  return url;
}

/**
 * Opens a Socket.IO connection to the backend's /video namespace
 * using the caller's JWT. Returns the socket instance (or null while connecting).
 */
export default function useVideoSocket(token) {
  const [socket, setSocket] = useState(null);
  const socketRef = useRef(null);

  useEffect(() => {
    if (!token) {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
        setSocket(null);
      }
      return;
    }

    const url = resolveSocketUrl();
    const s = io(`${url}/video`, {
      auth: { token },
      transports: ['websocket']
    });
    socketRef.current = s;

    s.on('connect', () => {
      console.log('[useVideoSocket] connected', s.id);
      setSocket(s);
    });
    s.on('disconnect', (reason) => {
      console.log('[useVideoSocket] disconnected', reason);
    });
    s.on('connect_error', (err) => {
      console.error('[useVideoSocket] connect_error', err.message);
    });

    return () => {
      console.log('[useVideoSocket] cleanup');
      s.disconnect();
      socketRef.current = null;
      setSocket(null);
    };
  }, [token]);

  return socket;
}
